import { useMutation } from "react-query";
import getFeatureFlagsList from "../services/getFeatureFlags";

function useGetFeatureFlagsList() {
  return useMutation(["get-feature-flags-list"], getFeatureFlagsList);
}

export default useGetFeatureFlagsList;
